<div class="relay-server-container">
	<section class="mat-typography heading">
		<div class="header-content">
			<div class="heading-text">Relay Server Management</div>
		</div>
		<hr />
	</section>
	<div class="main-container">
		@for (route of navRoutes; track route) {
<mat-card
			style="padding: 10px 25px;"
			(click)="GoToPage(route.route)">
			<div class="image-wrapper">
				<img [src]="route.imgSrc" />
			</div>
			<div class="content-wrapper">
				<div class="title-wrapper">
					<mat-card-title>{{ route.title }}</mat-card-title>
					<mat-card-subtitle>{{ route.description }}</mat-card-subtitle>
				</div>
				<button
					mat-raised-button
					color="navigator"
					>View</button
				>
			</div>
		</mat-card>
}
	</div>
	<hr />
	<div class="sub-heading mat-typography">
		<span class="text"> Grouped servers: </span>
	</div>
	<div class="group-heading mat-typography"> </div>
	<div class="content">
		@if (!loading) {
<div
			class="group-view"
		>
			@if (serverGroups.length > 0) {
<div
				class="group-content"
			>
				@for (group of serverGroups; track group; let i = $index) {
<div
					class="server-panel"
				>
					<mat-expansion-panel class="expansion-panel">
						<mat-expansion-panel-header>
							<mat-panel-title>
								<div
									class="group-name-link"
									(click)="
										redirect(
											$event,
											group.OriginalName != null ? group.OriginalName : group.GroupName
										)
									">
									{{ group.GroupName }}
								</div>
							</mat-panel-title>
						</mat-expansion-panel-header>
						<mat-panel-description class="table-container">
							<div class="chips">
								@for (server of group.Servers; track server) {
<div
									class="chips"
								>
									<mat-chip
										(click)="
											chipClick(
												server,
												group.OriginalName != null ? group.OriginalName : group.GroupName
											)
										"
										>{{ server.Name }}</mat-chip
									>
								</div>
}
							</div>
						</mat-panel-description>
					</mat-expansion-panel>
				</div>
}
			</div>
}
			@if (serverGroups.length == 0) {
<div> No group data </div>
}
			@if (serverGroups.length == 0) {
<div
			
				class="mat-typography">
				There are currently no servers assigned to groups.
			</div>
}
		</div>
}
		<div class="loader">
			@if (loading) {
<mat-spinner></mat-spinner>
}
		</div>
	</div>
</div>
